export const DEFAULT_DIRECT_LINK_VERSION = 1;
